<template>
  <div class="customer-overview">
    <div class="text-align-right">
      <a-button
        type="primary"
        icon="mail"
        class="margin-right-10"
        @click="_sendEmail"
      >
        发送邮件
      </a-button>
      <a-button type="primary" icon="download" @click="_overviewPdf">
        生成PDF
      </a-button>
    </div>
    <div class="customer-overview-content">
      <a-skeleton :loading="loading">
        <card-view
          id="mod1"
          title="企业主要资料"
          :column="column"
          :source-data="sourceData"
          :schema="CUSTOMER_MAIN_DATA"
        >
          <!--公司类型 slot-->
          <template v-slot:isParent="slotProps">
            <template v-if="slotProps.item.value == 0">无</template>
            <a-popover v-else trigger="click">
              <a-button type="link">
                {{ slotProps.item.value == 1 ? '母' : '子' }}公司（共{{
                  slotProps.item.value == 1
                    ? showData.length
                    : tableDataIsParent.length
                }}家{{ slotProps.item.value == 1 ? '子' : '母' }}公司）
              </a-button>
              <template slot="content">
                <div v-show="cartIsParent === 1">
                  <a-form layout="inline" class="card" :form="form">
                    <a-form-item label="公司ID/公司名称">
                      <a-input v-decorator="['codeOrName']" />
                    </a-form-item>
                    <a-form-item>
                      <a-button @click="handleSearch" type="primary">
                        查 询
                      </a-button>
                    </a-form-item>
                  </a-form>
                  <table-view
                    size="small"
                    :columns="columnsIsParent"
                    :pagination="false"
                    :scroll="{ y: 200, x: 200 }"
                    :data="tableDataIsParent"
                    rowKey="code"
                  >
                    <template v-slot:code="{ tableRow }">
                      <a-button
                        size="small"
                        type="link"
                        @click="toClientDetail(tableRow)"
                      >
                        {{ tableRow.code }}
                      </a-button>
                    </template>
                    <template v-slot:name="{ tableRow }">
                      <a
                        size="small"
                        type="link"
                        @click="toClientDetail(tableRow)"
                      >
                        {{ tableRow.name }}
                      </a>
                    </template>
                    <template v-slot:insCoverRate="{ tableRow }">
                      <a
                        size="small"
                        type="link"
                        @click="toClientDetail(tableRow)"
                      >
                        {{ tableRow.insCoverRate }}
                      </a>
                    </template>
                  </table-view>
                  <a-button
                    @click="handleUpload"
                    type="primary"
                    style="margin-left:500px;margin-top:20px;"
                  >
                    下载
                  </a-button>
                </div>
                <div v-show="cartIsParent === 2">
                  <table-view
                    size="small"
                    :columns="columnsIsParent2"
                    :pagination="false"
                    :data="tableDataIsParent"
                    rowKey="code"
                  >
                    <template v-slot:code="{ tableRow }">
                      <a-button
                        size="small"
                        type="link"
                        @click="toClientDetail(tableRow)"
                      >
                        {{ tableRow.code }}
                      </a-button>
                    </template>
                    <template v-slot:name="{ tableRow }">
                      <a-button
                        size="small"
                        type="link"
                        @click="toClientDetail(tableRow)"
                      >
                        {{ tableRow.name }}
                      </a-button>
                    </template>
                  </table-view>
                </div>
              </template>
            </a-popover>
          </template>
        </card-view>
      </a-skeleton>
      <a-divider />
      <a-skeleton :loading="loading">
        <card-view
          id="mod2"
          title="信用额度"
          :column="column"
          :source-data="sourceCreditLimit"
          :schema="CREDIT_LIMIT"
          class="margin-top-40"
        >
          <template v-slot:cosnameSlot>
            <a-tooltip>
              已生效限额(元)
            </a-tooltip>
          </template>
          <template v-slot:totalCreditLimit="slotProps">
            <template
              v-if="
                slotProps.item.value === '0.00' || slotProps.item.value === ''
              "
            >
              {{ slotProps.item.value }}
            </template>
            <a-popover v-else>
              <a-button type="link">{{ slotProps.item.value }}</a-button>
              <template slot="content">
                <table-view
                  size="small"
                  :columns="columnsValidLimitAmount"
                  :pagination="false"
                  :data="validLimitAmountList"
                ></table-view>
              </template>
            </a-popover>
          </template>

          <!--未生效额度 slot-->
          <template v-slot:norvalidAmount>
            <template v-if="columnsnorValidAmount !== ''">
              <a-descriptions-item label="未生效限额">
                {{ formatAmount(columnsnorValidAmount.amount) }}
              </a-descriptions-item>
              <a-descriptions-item label="限额条件">
                {{ columnsnorValidAmount.limitConditionAmount || '无限额条件' }}
              </a-descriptions-item>
              <a-descriptions-item label="未生效有效期">
                {{
                  moment(columnsnorValidAmount.indateStart).format('YYYY-MM-DD')
                }}
                -
                {{
                  moment(columnsnorValidAmount.indateEnd).format('YYYY-MM-DD')
                }}
              </a-descriptions-item>
            </template>
            <template v-else>
              <a-descriptions-item label="未生效限额">0.00</a-descriptions-item>
              <a-descriptions-item label="限额条件"></a-descriptions-item>
              <a-descriptions-item label="未生效有效期"></a-descriptions-item>
            </template>
          </template>
          <template v-slot:earliestDate>
            {{ earliestDate }}
          </template>

          <!--当前有效额度 slot-->
          <template v-slot:validAmount="slotProps">
            <template
              v-if="
                slotProps.item.value === '0.00' || slotProps.item.value === ''
              "
            >
              {{ slotProps.item.value }}
            </template>
            <a-popover v-else>
              <a-button type="link">{{ slotProps.item.value }}</a-button>
              <template slot="content">
                <table-view
                  size="small"
                  :columns="columnsValidAmount"
                  :pagination="false"
                  :data="tableDataValidAmount"
                ></table-view>
              </template>
            </a-popover>
          </template>
        </card-view>
      </a-skeleton>
      <a-divider />
      <a-skeleton :loading="loading">
        <h3 class="margin-top-40">客户账龄余额</h3>
        <table-view
          id="mod3"
          :columns="columns"
          :data="tableData"
          :pagination="pagination"
        ></table-view>
      </a-skeleton>

      <a-skeleton :loading="loading">
        <h3 class="margin-top-40">账期</h3>
        <table-view
          id="mod4"
          :columns="segments"
          :data="segmentData"
          :pagination="pagination"
        ></table-view>
      </a-skeleton>
      <!--锚点-->
      <a-anchor
        :target-offset="targetOffset"
        :affix="true"
        class="anchor-wrap"
        @click="handleClick"
      >
        <a-anchor-link href="#mod1" title="企业主要资料" />
        <a-anchor-link href="#mod2" title="信用额度" />
        <a-anchor-link href="#mod3" title="客户账龄余额" />
        <a-anchor-link href="#mod4" title="账期" />
      </a-anchor>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { CardView, TableView } from 'lxfintech-fe'
import {
  CUSTOMER_MAIN_DATA,
  CREDIT_LIMIT,
  columns,
  segments,
  columnsIsParent,
  columnsIsParent2,
  columnsValidAmount,
  columnsValidLimitAmount,
} from './schema.js'
import {
  getCustomerOverviewSegment,
  getCustomerOverview,
  sendEmail,
  overviewPdf,
  getinsCoverRate,
  getuploadinsCoverRate,
} from './api'
import numeral from 'numeral'
import { SET_COMPANY, SET_PERMISSIONS } from 'config/mutation-types/app'
import { mapMutations } from 'vuex'
import { arrayToObject } from 'utils/util'
export default {
  components: {
    CardView,
    TableView,
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'codeName' }),
      CUSTOMER_MAIN_DATA,
      CREDIT_LIMIT,
      columns,
      segments,
      moment,
      columnsIsParent,
      columnsIsParent2,
      columnsValidAmount,
      columnsValidLimitAmount,
      columnsnorValidAmount: {},
      validLimitAmountList: [],
      sourceData: {
        code: '',
        business: '',
        stdAccountPeriod: '',
        creditLevel: '',
        signDate: '',
        registerDate: '',
        region: '',
        registeredNo: '',
        country: '',
        province: '',
        creditManager: '',
        isParent: '',
        notStartedLimit: '',
        defaultScoreType: '',
        insCoverRate: '',
        source: '',
      },
      sourceCreditLimit: {
        totalCreditLimit: '',
        earliestDate: '',
        groupExposure: '',
        norvalidAmount: '',
        limitControlAmount: '',
        groupTotalAmount: '',
        creditLimitExposure: '',
        normalAmount: '',
        tempAmount: '',
        specialAmount: '',
        validAmount: '',
        onRoadLimit: '',
        onRoadNormal: '',
        onRoadTemp: '',
        onRoadSpecial: '',
      },
      tableData: [],
      segmentData: [],
      basicInfo: {},
      cartIsParent: '',
      showData: [],
      column: 3,
      targetOffset: undefined,
      pagination: false,
      loading: true,
      tableDataIsParent: [],
      tableDataValidAmount: [],
      tableDataNorValidAmount: [],
      earliestDate: '',
    }
  },
  mounted() {
    this.targetOffset = window.innerHeight / 2
    this.getData()
    this._getinsCoverRate()
    this.getCustomerOverviewSegments()
  },
  created() {
    this.clientId = this.$route.params.id
  },
  methods: {
    ...mapMutations('app', [SET_COMPANY, SET_PERMISSIONS]),
    async getCustomerOverviewSegments() {
      try {
        const { data } = await getCustomerOverviewSegment(this.clientId)
        this.segmentData = data
      } catch (error) {
        console.log(error)
      }
    },
    async _getinsCoverRate() {
      const { data } = await getCustomerOverview(this.clientId)
      this.parentCode = data.code
      this.cartIsParent = data.isParent
      this.basicInfo = { ...data }
      const params = {
        parentCode: this.parentCode,
      }
      try {
        if (this.cartIsParent === 1) {
          const { data } = await getinsCoverRate(params)
          this.showData = data
          this.tableDataIsParent = data
        } else {
          this.tableDataIsParent = this.basicInfo.relations
        }
      } catch (error) {
        console.log(error)
      }
    },
    formatAmount(num) {
      return numeral(num).format('0,0.00')
    },
    resetAmount(num) {
      return numeral(num).format('0.00')
    },
    async getData() {
      try {
        const { data } = await getCustomerOverview(this.clientId)
        const minus =
          Number(this.resetAmount(data.creditAmount.totalCreditLimit)) -
          Number(data.creditAmount.groupTotalAmount)
        data.creditAmount.groupExposure = minus
        if (data.isParent === 1) {
          delete this.CREDIT_LIMIT.creditLimitExposure
          this.CREDIT_LIMIT.groupExposure = {
            key: 'groupExposure',
            label: '集团限额敞口',
            value: minus,
          }
        } else {
          this.CREDIT_LIMIT.creditLimitExposure = {
            key: 'creditLimitExposure',
            label: '信用限额敞口',
            value: data.creditAmount.creditLimitExposure,
          }
          this.CREDIT_LIMIT.earliestDate = {
            key: 'earliestDate',
            slotName: 'earliestDate',
            label: '最近额度到期日',
            value: this.earliestDate,
          }
          delete this.CREDIT_LIMIT.groupExposure
        }
        if (data.isParent !== 2) {
          delete this.CREDIT_LIMIT.earliestDate
        }
        this.parentCode = data.code
        this.columnsnorValidAmount = data.creditAmount.notStartedLimit
        if (data.creditAmount.earliestDate) {
          this.earliestDate = moment(data.creditAmount.earliestDate).format(
            'YYYY-MM-DD',
          )
        }

        this.validLimitAmountList = data.creditAmount.validLimitAmountList
        this.loading = false

        for (let key in data) {
          this.sourceData[key] = data[key]
          switch (key) {
            // 公司类型 table数据
            // case 'relations':
            //   this.tableDataIsParent = data[key]
            //   break

            // 信用额度
            case 'creditAmount':
              for (let j in data[key]) {
                //限额条件
                if (j === 'limitControlAmount') {
                  if (data[key][j] == '') {
                    this.sourceCreditLimit[j] = '无'
                  } else {
                    this.sourceCreditLimit[j] =
                      'NET AR 超' + this.formatAmount(data[key][j]) + '元控货'
                  }
                } else if (j === 'validAmountList') {
                  // 当前有效额度  table数据
                  this.tableDataValidAmount = data[key][j]
                } else if (j === 'notStartedLimit') {
                  this.sourceCreditLimit[j] = this.formatAmount(data[key][j])
                } else {
                  this.sourceCreditLimit[j] = this.formatAmount(data[key][j])
                }
              }
              break

            //客户账龄余额 mock 数据
            case 'customerAr':
              this.tableData = [
                {
                  id: '尚未逾期',
                  amount: this.formatAmount(data[key].notOverdue),
                  rate: data[key].notOverdueRate,
                },
                {
                  id: '逾期1-30天',
                  amount: this.formatAmount(data[key].overdueOne),
                  rate: data[key].overdueOneRate,
                },
                {
                  id: '逾期31-60天',
                  amount: this.formatAmount(data[key].overdueThirty),
                  rate: data[key].overdueThirtyRate,
                },
                {
                  id: '逾期61-90天',
                  amount: this.formatAmount(data[key].overdueSixty),
                  rate: data[key].overdueSixtyRate,
                },
                {
                  id: '逾期91-180天',
                  amount: this.formatAmount(data[key].overdueNinety),
                  rate: data[key].overdueNinetyRate,
                },
                {
                  id: '逾期180天以上',
                  amount: this.formatAmount(data[key].overdueHundredEighty),
                  rate: data[key].overdueHundredEightyRate,
                },
                {
                  id: 'Total AR',
                  amount: this.formatAmount(data[key].arAmount),
                  rate: data[key].arAmountRate,
                },
                {
                  id: '未清来款',
                  amount: this.formatAmount(data[key].amountReceipt),
                  rate: data[key].amountReceiptRate,
                },
                {
                  id: 'Net AR',
                  amount: this.formatAmount(data[key].netAr),
                  rate: data[key].netArRate,
                },
                {
                  id: '集团Net AR',
                  amount: this.formatAmount(data[key].groupNetAr),
                  rate: data[key].groupNetArRate,
                },
              ]
              break
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    async handleUpload() {
      const params = {
        parentCode: this.parentCode,
      }
      await getuploadinsCoverRate(params)
    },
    async handleSearch() {
      const codeOrName = this.form.getFieldValue('codeOrName')
      const params = {
        childCode: codeOrName,
        parentCode: this.parentCode,
      }
      const { data } = await getinsCoverRate(params)
      this.tableDataIsParent = data
    },
    // 发送邮箱
    async _sendEmail() {
      try {
        const { message } = await sendEmail(this.clientId)
        this.$message.success(message)
      } catch (err) {
        console.log(err)
      }
    },
    // 下载pdf
    _overviewPdf() {
      try {
        overviewPdf(this.clientId)
      } catch (err) {
        console.log(err)
      }
    },
    // 锚点
    handleClick(e, link) {
      e.preventDefault()
      this.$router.push({
        name: 'overview',
        params: { mod: link.href.slice(1, 5) },
      })
    },
    // TODO: 待测
    async toClientDetail(row) {
      const { id, code, name } = row
      this.SET_COMPANY({ name, code })
      this.$router.push({ name: 'trend', params: { id, code } })
      const {
        data: { permissions },
      } = await getCustomerOverview(id)
      if (permissions) {
        this.SET_PERMISSIONS(arrayToObject(permissions, 'tab', 'buttons'))
      }
    },
  },
}
</script>
<style lang="less" scoped>
.customer-overview {
  background-color: #fff;
  padding-top: 20px;
  /deep/ .customer-overview-content {
    width: 80%;
    margin: 0 0 40px 40px;
  }
  /deep/ .text-align-right {
    width: 98.5%;
    text-align: right;
  }
  /deep/ .margin-right-10 {
    margin-right: 10px;
  }
  /deep/ .margin-top-40 {
    margin-top: 40px;
  }
  /deep/ .anchor-wrap {
    position: fixed;
    right: 30px;
    top: 400px;
  }
}
</style>
